module.exports = __webpack_public_path__ + "img/img-3.97f2c417.gif";